<template>
    <div>
        <DialogoFotos ref="dialFotos" :titulo="titulo" :tipo="tipo" width="500" />
        <DialogoBlockTramite ref="dialBlock" type="familiares" width="500" />
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="formDatosAfi" @submit.prevent="enviarDatos" :disabled="deshabilitar">
                <v-card class="custom-card" flat>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-card-text class="font-weight-bold text-body-1 black--text" ref="cardText">
                                MIS DATOS PERSONALES
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-row class="text-center">
                        <v-col cols="12" md="3" class="d-flex justify-center">
                            <!-- <InputSelectorFoto label="foto de legajo" op="legajo" :fotoafi="datosAfi.fotocarnet" /> -->
                            <v-col cols="12" md="12">
                                <div ref="fotoLegajo"
                                    class="font-weight-bold primary--text text--lighten-1 text-body-1 mb-2">
                                    FOTO DE LEGAJO
                                </div>
                                <!-- :class="{ 'error-avatar': !fotoCarnet && errors.length }"> -->
                                <v-avatar size="180" tile style="position: relative;" class="elevation-1"
                                    :class="{ 'error-avatar': !fototmpcarnet && errors.length }">
                                    <v-img v-if="fototmpcarnet" :src="`data:image/png;base64,${fototmpcarnet}`"></v-img>
                                    <v-img v-else-if="fotoCarnet" :src="`data:image/png;base64,${fotoCarnet}`"></v-img>
                                    <v-img v-else src="@/assets/blank-user-profile.png" />
                                    <v-btn small color="primary" class="py-5 px-8" @click="lanzarDialogo"
                                        style="position: absolute; top: 78%;  ">
                                        <v-icon class="mr-2">mdi-camera-plus-outline</v-icon>agregar foto
                                    </v-btn>
                                </v-avatar>
                            </v-col>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-row class="mt-4">
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="datosAfi.nombres" label="Nombres"
                                            :error-messages="v.errors[0]"
                                            @input="datosAfi.nombres = datosAfi.nombres.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="datosAfi.apellido" label="Apellido"
                                            :error-messages="v.errors[0]" :placeholder="user.apellido"
                                            @input="datosAfi.apellido = datosAfi.apellido.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|length:8|numeric" v-slot="v">
                                        <v-text-field dense v-model="datosAfi.nrodoc" type="number" hide-spin-buttons
                                            label="DNI Nro." :error-messages="v.errors[0]" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="datosAfi.sexo" :items="itemSexo" label="Sexo"
                                            :error-messages="v.errors[0]">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider
                                        :rules="{ required: true, numeric: true, length: 11, validCuil: { dni: datosAfi.nrodoc } }"
                                        v-slot="v">
                                        <v-text-field dense v-model="datosAfi.cuil" type="number" hide-spin-buttons
                                            label="CUIL" :error-messages="v.errors[0]" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <ValidationProvider rules="required|max:10|menoranios:130" v-slot="v">
                                        <v-text-field v-model="datosAfi.fecnacim" dense label="Fecha de nacimiento"
                                            type="date" :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-autocomplete dense v-model="datosAfi.nacionalidad" :items="nacionalidades"
                                            item-value="id" @input="selectNacionalidad" item-text="desnacionalidad"
                                            return-object label="Nacionalidad" :error-messages="v.errors[0]">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-autocomplete dense v-model="datosAfi.tiponacionalidad"
                                            :error-messages="v.errors[0]" :items="tipoNacionalidad" item-value="tna_id"
                                            item-text="tna_destipnac" label="Tipo de nacionalidad" return-object
                                            @input="selectTipNacionalidad">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" :md="mostrarFecha ? 6 : 12">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="datosAfi.estadocivil" @input="selectEstCivil"
                                            :items="estadoCivil" item-value="id" item-text="desestadocivil"
                                            return-object label="Estado Civil" :error-messages="v.errors[0]">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" v-if="mostrarFecha">
                                    <ValidationProvider rules="required|max:10|nofechafutura" v-slot="v">
                                        <v-text-field v-model="datosAfi.fecestadocivil" dense data-skip-on-tab="true"
                                            label="Fecha de estado civil" type="date"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <div v-if="dniRequired">
                        <v-divider class="my-5"></v-divider>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                DOCUMENTACIÓN REQUERIDA:
                            </v-card-text>
                        </v-row>
                        <v-row class="d-flex flex-row align-end justify-start"
                            :class="($vuetify.breakpoint.smAndDown) ? 'justify-center' : 'justify-space-around'">
                            <InputButtonArchivo op="dniFrenteAfiliado" label="DNI FRENTE"
                                @fileSelected="handleFileSelected"
                                :subtitle="datosAfi.nombres + ' ' + datosAfi.apellido" :disabled="!dniRequired" />
                            <InputButtonArchivo op="dniDorsoAfiliado" label="DNI DORSO"
                                @fileSelected="handleFileSelected"
                                :subtitle="datosAfi.nombres + ' ' + datosAfi.apellido" :disabled="!dniRequired" />
                        </v-row>
                    </div>
                    <v-card-actions class="d-flex align-center custom-card-actions-ha" @click="forzarValidacion">
                        <v-spacer></v-spacer>
                        <v-btn v-if="btnSiguiente" color="primary" elevation="0" class="pa-5" :disabled="invalid"
                            @click="siguientePaso">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>
                            siguiente
                        </v-btn>
                        <v-btn v-else type="submit" class="pa-5" color="primary" :disabled="invalid || !formValid">
                            <v-icon class="mr-2">mdi-send</v-icon>
                            enviar trámite
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import DialogoBlockTramite from '@/components/dialogos/DialogoBlockTramite.vue'
import DialogoFotos from '@/components/dialogos/DialogoFotos.vue'
import Alertas from '@/components/alerts/Alertas.vue'
import InputSelectorFoto from '@/components/inputs/InputSelectorFoto.vue'
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue'
import InputButtonDniDorso from '@/components/inputs/InputButtonDniDorso.vue'

export default {
    name: "form-datos-afi",
    components:
    {
        ValidationProvider,
        ValidationObserver,
        InputButtonArchivo,
        InputButtonDniDorso,
        Alertas,
        InputSelectorFoto,
        DialogoFotos,
        DialogoBlockTramite,
    },
    data() {
        return {
            datosAfi: {
                nroafi: '',
                //pmaid: '',
                nombres: '',
                apellido: '',
                tipdoc: '',
                nrodoc: '',
                cuil: '',
                sexo: '',
                fecnacim: '',
                fecestadocivil: '',
                nacionalidad: '',
                desnacionalidad: '',
                estadocivil: '',
                tiponacionalidad: '',
                desestadocivil: '',
                destipnacionalidad: '', // interno
                fotocarnet: '',
            },
            cambioEstadoCivil: false,
            btnSiguiente: false,

            afiliadoObject: {
            },
            itemTipDni: ['DNI'], // item select tipo de dni
            itemSexo: ['F', 'M', 'X'], // item select sexo
            valid: false,
            deshabilitar: false,
            titulo: '',
            tipo: '',
            formValid: false,
            labelInfo: '',
            overlay: false,
            checkbox: false,
            discapacidadOptions: [
                { text: 'SI', value: 'S' },
                { text: 'NO', value: 'N' },
            ],
            errors: [],
            originalData: {}, // Store the original data for comparison
            dniRequired: false, // Flag to indicate if DNI upload is required
        }

    },
    mounted() {
        if (this.user) {
            const userFields = [
                'nroafi', 'nombres', 'apellido', 'cuil',
                'sexo', 'fecnacim', 'tipdoc', 'nrodoc', 'estadocivil',
                'fecestadocivil', 'nacionalidad', 'tiponacionalidad',
            ];

            userFields.forEach(field => {
                this.datosAfi[field] = this.user[field];
            });
            this.datosAfi.desestadocivil = this.descEstCivil(this.user.estadocivil);
            this.datosAfi.desnacionalidad = this.descNacionalidad(this.user.nacionalidad);
            this.datosAfi.destipnacionalidad = this.descNacionalidad(this.user.tiponacionalidad);
            this.datosAfi.fotocarnet = this.fotoCarnet
        }
    },
    computed: {
        ...mapGetters('auth', ['user', 'nroafi', 'isAuthenticated']),
        ...mapGetters('common', ['nacionalidades', 'estadoCivil', 'tipoNacionalidad', 'tipoDoc']),
        ...mapGetters('opcionNivel', ['opcionNivelAfiliado']),
        ...mapGetters('dataUser', ['blockFotoCarnet', 'fotoCarnet', 'fototmp', 'fototmpcarnet',
            'dniFrenteAfiliado', 'dniDorsoAfiliado', 'dniFrenteAfiliado', 'hayDatosFamiliares',
            'hayDatosPersonales']),

        labelFecha() {
            if (this.datosAfi.estadocivil == 2) {
                return 'Fecha de matrimonio'
            } else if (this.datosAfi.estadocivil == 9) {
                return 'Fecha de unión convivencial'
            } else if (this.datosAfi.estadocivil == 5) {
                return 'Fecha de divorcio'
            } else if (this.datosAfi.estadocivil == 11) {
                return 'Fecha de inicio de convivencia'
            } else {
                return 'Fecha de estado civil'
            }
        },
        mostrarFecha() {
            return (this.datosAfi.estadocivil == 2) || (this.datosAfi.estadocivil == 5) || (this.datosAfi.estadocivil == 7) || (this.datosAfi.estadocivil == 9)
        },
        /*         necesitaArchivos() {
                    return (this.datosAfi.estadocivil == 2) || (this.datosAfi.estadocivil == 3) || (this.datosAfi.estadocivil == 6) || (this.datosAfi.estadocivil == 9)
                }, */
        fotoAfiCargada() {
            return (this.fototmpcarnet !== '')
        },
        cuilCompleto() {
            return `${this.pref}${this.datosAfi.nrodoc}${this.suf}`
        },
        documentacionRequerida() {
            if (this.dniRequired)
                return this.dniFrenteAfiliado.length !== 0 && this.dniDorsoAfiliado.length !== 0
            else return false
        },

    },
    watch: {
        datosAfi: {
            deep: true,
            handler(newVal) {
                if (this.fototmpcarnet) {
                    this.dniRequired = true; // Set to true if fototmpcarnet has a value
                } else {
                    this.dniRequired = ['nombres', 'apellido', 'nrodoc', 'sexo', 'cuil', 'fecnacim', 'nacionalidad', 'tiponacionalidad'].some(
                        key => newVal[key] !== this.user[key]
                    );
                }
            }
        },
        // si sube foto debe adjuntar dni
        fototmpcarnet: {
            handler(newVal) {
                if (newVal) {
                    this.dniRequired = true
                    this.datosAfi.fotocarnet = this.fototmpcarnet
                } else {
                    this.dniRequired = false
                    this.datosAfi.fotocarnet = ''
                }
            }
        }
    },
    methods: {
        ...mapActions('dataUser', ['actualizarDatos', 'cargarFormDataArchivos', 'guardarDatosPersonales', 'preparaFormPersonales', 'guardarDatosAfiliado', 'guardarObjetoEstadoCivil']),
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        //Bloqueo de teclas
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        selectEstCivil(value) {
            const selectedEstadoCivil = value.id;
            const currentEstadoCivil = this.user.estadocivil;

            // Si el estado civil seleccionado es igual al actual, no hacer nada
            if (currentEstadoCivil === selectedEstadoCivil) {
                this.resetEstadoCivil();
                return;
            }

            if (selectedEstadoCivil == 3 || selectedEstadoCivil == 4 || selectedEstadoCivil == 6) {
                this.showSnack({
                    type: '400',
                    message: 'El estado civil seleccionado no está disponible para este trámite.'
                });
                this.datosAfi.estadocivil = this.currentEstadoCivil;
                return;
            }

            // Casos específicos según el estado civil actual
            switch (currentEstadoCivil) {
                /*                 case 1: // Soltero
                                    if (selectedEstadoCivil === 11) { // Permitir Conviviente
                                        this.updateEstadoCivil(selectedEstadoCivil, "1900-01-01", false);
                                    } else {
                                        this.showProhibitedChangeDialog();
                                    }
                                    break; */
                case 1: // Soltero
                    this.showProhibitedChangeDialog();
                    break;

                case 2: // Casado
                    if ([1, 9, 11].includes(selectedEstadoCivil)) { // Prohibir 1-Soltero, 9-Unión convivencial, 11-Conviviente
                        this.showProhibitedChangeDialog()
                        this.resetEstadoCivil();
                    } else if ([7, 5].includes(selectedEstadoCivil)) { // Permitir Divorciado, Viudo
                        this.updateEstadoCivil(selectedEstadoCivil, "", true);
                    } else if (selectedEstadoCivil === 10) { // Permitir Estado Civil separado 10
                        this.updateEstadoCivil(selectedEstadoCivil, this.user.fecestadocivil, false, true); // Habilitar botón "Enviar trámite"
                    } else {
                        this.updateEstadoCivil(selectedEstadoCivil, "", false);
                    }
                    break;

                case 5: // Divorciado
                    if ([1, 2, 7, 9, 11].includes(selectedEstadoCivil)) // Prohibir Soltero, Casado, Unión convivencial
                        this.showProhibitedChangeDialog();
                    break;
                case 6: // Viudo
                    if ([2, 9].includes(selectedEstadoCivil)) { // Prohibir Casado, Unión convivencial
                        this.showProhibitedChangeDialog();
                    } else {
                        this.updateEstadoCivil(selectedEstadoCivil, "", true);
                    }
                    break;
                case 9: // Unión convivencial
                    if ([2, 5, 7, 11].includes(selectedEstadoCivil)) {
                        this.showProhibitedChangeDialog()
                        break;
                    } else if ([1].includes(selectedEstadoCivil)) {
                        this.updateEstadoCivil(selectedEstadoCivil, "", true); // Habilitar botón "Siguiente"
                    }
                    break;
                case 7: // Viudo
                    this.showProhibitedChangeDialog();
                    break;
                case 10: // Separado
                case 11: // Conviviente
                    this.showProhibitedChangeDialog();
                    break;
                default:
                    // Caso por defecto: permitir el cambio
                    this.updateEstadoCivil(selectedEstadoCivil, "", false);
                    break;
            }
        },
        resetEstadoCivil() {
            this.datosAfi.estadocivil = this.user.estadocivil;
            this.datosAfi.fecestadocivil = this.user.fecestadocivil;
            this.btnSiguiente = false;
            this.$emit('cambioEstadoCivil', false);
        },
        updateEstadoCivil(estadoCivil, fechaEstadoCivil, btnSiguiente, cambioEstadoCivil = false) {
            this.datosAfi.estadocivil = estadoCivil;
            this.datosAfi.fecestadocivil = fechaEstadoCivil;
            this.btnSiguiente = btnSiguiente;
            this.formValid = cambioEstadoCivil; // Habilitar botón "Enviar trámite"
            this.$emit('cambioEstadoCivil', cambioEstadoCivil);
        },
        showProhibitedChangeDialog() {
            this.$refs.dialBlock.abrirDialogo().then(() => {
                this.resetEstadoCivil();
            })
        },
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                this.onBlur();
            });
        },

        onBlur() {
            if (!this.fotoCarnet) {
                this.errors = ['Debes agregar una foto de legajo']
                this.$refs.fotoLegajo.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            else this.errors = []
        },


        habilitaEdicion() {
            this.guardarDatosPersonales({})
            this.deshabilitar = false
        },
        cambiarEstado(value) {
            this.deshabilitar = value
        },
        descEstCivil(id) {
            const dato = this.estadoCivil.find(e => e.id == id)
            return dato.desestadocivil
        },
        descNacionalidad(id) {
            const dato = this.nacionalidades.find(e => e.id == id)
            return dato.desnacionalidad
        },
        descTipoNacionalidad(id) {
            const dato = this.tipoNacionalidad.find(e => e.tna_id == id)
            return dato.tna_destipnac
        },
        actualizarData() {
            this.deshabilitar = false
        },
        async iniciar() {
            //if (this.hayDatosPersonales) {
            if (true) {
                this.guardarDatosPersonales(this.datosAfi)
                await this.preparaFormPersonales()
                this.$emit('handleDialog')
                location.reload()
            } else {
                this.showSnack({
                    message: 'No hay datos para enviar',
                    type: '400'
                })
            }
        },
        siguientePaso() {
            this.guardarDatosPersonales(this.datosAfi)
            this.$emit('siguiente')
        },
        async enviarDatos() {
            if (!(await this.$refs.obs?.validate?.())) {
                this.showSnack({
                    type: '400',
                    message: 'Formulario inválido, revisá los campos.'
                });
            } else {
                this.guardarDatosPersonales({
                    ...this.datosAfi,
                    fotocarnet: this.fototmpcarnet || this.fotoCarnet || this.datosAfi.fotocarnet
                });
                this.preparaFormPersonales()
                this.$emit('handleDialog');
            }
        },
        /* enviarDatos() {
            this.$refs.obs.validate().then(isValid => {
                if (!isValid) {
                    this.showSnack({
                        type: '400',
                        message: 'Formulario inválido, revise los campos.'
                    });
                    return;
                }
 
                if (this.fotoCarnet) {
                    this.datosAfi.fotocarnet = this.fotoCarnet;
                }
                this.guardarDatosPersonales({ ...this.datosAfi });
                this.preparaFormPersonales();
            });
        }, */
        handleFileSelected() {
            if (this.dniRequired) {
                this.formValid = this.dniFrenteAfiliado.length !== 0 && this.dniDorsoAfiliado.length !== 0;
            } else {
                this.formValid = true;
            }
        },
        selectNacionalidad(value) {
            this.datosAfi.nacionalidad = value.id
            this.datosAfi.desnacionalidad = value.desnacionalidad
        },
        selectTipNacionalidad(value) {
            this.datosAfi.tiponacionalidad = value.tna_id
            this.datosAfi.destipnacionalidad = value.tna_destipnac
        },
        lanzarDialogo() {
            this.titulo = "Foto de legajo"
            this.tipo = "fotocarnet"
            this.$refs.dialFotos.abrirDialogo()
        },
        lanzarDialogoFoto() {
            this.titulo = "Foto de legajo"
            this.tipo = "fotocarnet"
            this.$refs.dialogo.abrirDialogo()
        },
        updateCuil(value) {
            this.datosAfi.cuil = this.pref + this.datosAfi.dni + this.suf
        }
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
            required: false,
        },
        index: {
            type: Number,
            default: 0
        },

    }
    //props: ['loading', 'index']
}

</script>

<style scoped>
.btn-fade-in-out {
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
}

.error-avatar {
    border: 2px solid red;
}

.btn-fade-in-out:hover {
    opacity: 1;
}

.custom-checkbox {
    border-color: primary;
}

.form-content {
    min-height: calc(100vh - 80px);
    /* Ajustar para dejar espacio para el footer */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.custom-card-actions-ha {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}

.error-avatar {
    border: 2px solid red;
}
</style>
